<template>
  <div>
    <vm-table ref="vmTable" v-loading="loading" :filter.sync="search" url="potentialFaults">
      <template slot="adSearch">
        <vm-search :label="$l('maintWorkOrder.filter', '关键字检索')">
          <el-input v-model.trim="search.filter" :placeholder="$t('common.search')" clearable></el-input>
        </vm-search>
        <vm-search :label="$t('elevator.useUnit')">
          <vm-select-input v-model="search.useUnitName" clearable @clear="search.useUnitId = ''"
            @select="$refs.selectUseUnitProperty.open()"></vm-select-input>
          <use-unit-select ref="selectUseUnitProperty" @select="onSelectUseUnit"></use-unit-select>
        </vm-search>
      </template>
      <el-table-column prop="no" :label="$t('elevator.no')" width="120" align="center"></el-table-column>
      <el-table-column prop="name" :label="$t('elevator.name')" show-overflow-tooltip></el-table-column>
      <el-table-column prop="useUnitName" :label="$t('elevator.useUnit')" show-overflow-tooltip></el-table-column>
      <el-table-column prop="value" :label="$t('potentialFault.healthIndex')" width="100" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.value > 80">
            <el-tag type="success">{{ $t("potentialFault.healthIndex_high") }}</el-tag>
          </div>
          <div v-else-if="scope.row.value > 60">
            <el-tag type="warning">{{ $t("potentialFault.healthIndex_middle") }}</el-tag>
          </div>
          <div v-else>
            <el-tag type="danger">{{ $t("potentialFault.healthIndex_low") }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.operation')" width="80" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleClick(scope.row)">{{ $t("common.detail") }}</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <list-dialog ref="listPage"></list-dialog>
  </div>
</template>
<script>
import ListDialog from "./PotentialFaultList.vue";
import UseUnitSelect from "../company/useUnitCom/UseUnitSelect.vue";
import VmSelectInput from "../../components/VmSelectInput";

export default {
  components: { ListDialog, UseUnitSelect, VmSelectInput },
  data() {
    return {
      loading: false,
      search: {
        filter: "",
        useUnitId: "",
        useUnitName: "",
      },
    };
  },
  mounted() {
    this.getList(1);
  },
  methods: {
    getList(pageNum) {
      this.$refs.vmTable.getList(pageNum);
    },
    handleClick(row) {
      this.$refs.listPage.open(row);
    },
    onSelectUseUnit(row) {
      this.search.useUnitId = row.id;
      this.search.useUnitName = row.name;
    },
  },
};
</script>
<style lang="scss" scoped></style>
